import React, { useEffect, useRef } from "react";
import Thether from "react-tether";

const Item = ({ text, onClick }) => {
  return (
    <li
      className="select-menu__menu-item"
      role="menuitem"
      tabIndex={-1}
      onClick={onClick}
    >
      {text}
    </li>
  );
};

const SelectMenuButton = React.forwardRef(
  ({ id, listId, isOpen, children }, ref) => (
    <span
      ref={ref}
      className="select-menu"
      id={id}
      role="button"
      aria-haspopup="menu"
      aria-controls={listId}
      aria-expanded={isOpen}
    >
      {children}
    </span>
  )
);

const SelectMenu = ({
  id,
  message,
  children,
  items,
  isOpen,
  onRequestClose,
  onSelect,
}) => {
  const mutableRef = useRef({
    id: null,
    listId: null,
    onRequestClose: null,
    isOpen: null,
  });

  const listId = `${id}-list`;
  mutableRef.current.id = id;
  mutableRef.current.listId = listId;
  mutableRef.current.onRequestClose = onRequestClose;
  mutableRef.current.isOpen = isOpen;

  useEffect(() => {
    const { id, listId } = mutableRef.current;
    const listener = (e) => {
      if (mutableRef.current.isOpen) {
        let target = e.target;
        while (target) {
          if (target.id === id || target.id === listId) {
            return;
          }
          target = target.parentNode;
        }
        mutableRef.current.onRequestClose?.(e);
        e.preventDefault();
        e.stopPropagation();
      }
    };
    document.addEventListener("click", listener);
    return () => document.removeEventListener("click", listener);
  }, []);

  return !isOpen ? (
    <SelectMenuButton id={id} listId={listId} isOpen={isOpen}>
      {children}
    </SelectMenuButton>
  ) : (
    <Thether
      attachment="top left"
      targetAttachment="bottom left"
      style={{ zIndex: 49 }}
      constraints={[
        {
          to: "scrollParent",
          attachment: "together",
          pin: true,
        },
        {
          to: "window",
          attachment: "together",
          pin: true,
        },
      ]}
      renderTarget={(ref) => (
        <SelectMenuButton ref={ref} id={id} listId={listId} isOpen={isOpen}>
          {children}
        </SelectMenuButton>
      )}
      renderElement={(ref) =>
        message ? (
          <span ref={ref}>{message}</span>
        ) : (
          <ul
            ref={ref}
            className="select-menu__menu-list"
            role="menu"
            id={listId}
            aria-labelledby={id}
          >
            {items?.map((item) => (
              <Item
                key={item.value}
                text={item.text}
                onClick={() => onSelect(item.value)}
              />
            ))}
          </ul>
        )
      }
    />
  );
};

export default SelectMenu;
